<template lang="html">
  <SoundslidesPlayer :fillscreen="true" :solo-player="true" />
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer"
export default {
  name: "Player",
  components:{
    SoundslidesPlayer
  },
  data(){
    return {
    }
  }
}
</script>

<style lang="css" scoped>
</style>
